import { Routes } from '@angular/router';
import { authGuard } from './auth/auth.guard';
import { InitPageComponent } from '@pages/init/init-page.component';
import { CreationHomePageComponent } from './pages/create/creation-home-page/creation-home-page.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { MainLayoutComponent } from './pages/main-layout/main-layout.component';
import { PricingCarcassCollectionCustomersPageComponent } from './pages/pricing/customers/carcass-collection/pricing-carcass-collection-customers-page/pricing-carcass-collection-customers-page.component';
import { PricingEndProductCustomersPageComponent } from './pages/pricing/customers/end/pricing-end-product-customers-page/pricing-end-product-customers-page.component';
import { PricingLogisticsPageComponent } from './pages/pricing/partners/logistics/pricing-logistics-page/pricing-logistics-page.component';
import { PricingSlaughterhousesPageComponent } from './pages/pricing/partners/slaughterhouses/pricing-slaughterhouses-page/pricing-slaughterhouses-page.component';
import { PricingComponent } from './pages/pricing/pricing.component';
import { PricingByproductsPageComponent } from './pages/pricing/products/byproducts/pricing-byproducts-page/pricing-byproducts-page.component';
import { PricingEndProductsPageComponent } from './pages/pricing/products/end-products/pricing-end-products-page/pricing-end-products-page.component';
import { PricingServicesPageComponent } from './pages/pricing/services/pricing-services-page/pricing-services-page.component';
import { ViewLogisticsPageComponent } from './pages/view/partners/logistics/view-logistics-page/view-logistics-page.component';
import { ViewSlaughterhousesPageComponent } from './pages/view/partners/slaughterhouses/view-slaughterhouses-page/view-slaughterhouses-page.component';
import { ViewByproductsPageComponent } from './pages/view/products/byproducts/view-byproducts-page/view-byproducts-page.component';
import { ViewComponent } from './pages/view/view.component';
import { ListPricesForSlaughterhousePageComponent } from '@pages/pricing/partners/slaughterhouses/list-prices-for-slaughterhouse-page/list-prices-for-slaughterhouse-page.component';
import { ListPricesForLogisticsPageComponent } from '@pages/pricing/partners/logistics/list-prices-for-logistics-page/list-prices-for-logistics-page.component';
import { ViewSlaughterhouseDetailsComponent } from '@pages/view/partners/slaughterhouses/view-slaughterhouse-details/view-slaughterhouse-details.component';
import { ViewLogisticsDetailsComponent } from '@pages/view/partners/logistics/view-logistics-details/view-logistics-details.component';
import { ViewByproductDetailsComponent } from '@pages/view/products/byproducts/view-byproduct-details/view-byproduct-details.component';
// import { CreateByproductComponent } from '@pages/create/create-byproduct/create-byproduct.component';
// import { CreateCustomerComponent } from '@pages/create/create-customer/create-customer.component';
// import { CreateServiceComponent } from '@pages/create/create-service/create-service.component';
// import { CreateHaulierComponent } from '@pages/create/create-haulier/create-haulier.component';
import { PriceDetailsComponent } from '@pages/pricing/price-details/price-details.component';
import { ListPricesForByproductsPageComponent } from '@pages/pricing/products/byproducts/list-prices-for-byproducts-page/list-prices-for-byproducts-page.component';
import { CreateSlaughterhouseComponent } from '@pages/create/create-slaughterhouse/create-slaughterhouse.component';
import { CreateHaulierComponent } from '@pages/create/create-haulier/create-haulier.component';
import { CreateByproductComponent } from '@pages/create/create-byproduct/create-byproduct.component';
import { ViewServicesPageComponent } from '@pages/view/services/view-services-page/view-services-page.component';
import { ViewServiceDetailsComponent } from '@pages/view/services/view-service-details/view-service-details.component';
import { ListPricesForServicesPageComponent } from '@pages/pricing/services/list-prices-for-services-page/list-prices-for-services-page.component';

export const routes: Routes = [
  {
    path: 'app',
    component: MainLayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'create',
        canActivate: [authGuard],
        children: [
          {
            path: 'home',
            component: CreationHomePageComponent,
            canActivate: [authGuard]
          },
          {
            path: 'byproduct',
            component: CreateByproductComponent,
            canActivate: [authGuard]
          },
          {
            path: 'slaughterhouse',
            component: CreateSlaughterhouseComponent,
            canActivate: [authGuard]
          },
          {
            path: 'haulier',
            component: CreateHaulierComponent,
            canActivate: [authGuard]
          },
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'home'
          },
          {
            path: '**',
            redirectTo: 'home'
          }
        ]
      },
      {
        path: 'view',
        component: ViewComponent,
        canActivate: [authGuard],
        children: [
          {
            path: 'partners',
            canActivate: [authGuard],
            children: [
              {
                path: 'slaughterhouses',
                component: ViewSlaughterhousesPageComponent,
                canActivate: [authGuard]
              },
              { path: 'slaughterhouses/:slaughterhouseId', component: ViewSlaughterhouseDetailsComponent, canActivate: [authGuard] },
              {
                path: 'logistics',
                component: ViewLogisticsPageComponent,
                canActivate: [authGuard]
              },
              {
                path: 'logistics/:haulierId',
                component: ViewLogisticsDetailsComponent,
                canActivate: [authGuard]
              },
              {
                path: '',
                pathMatch: 'full',
                redirectTo: 'slaughterhouses'
              },
              {
                path: '**',
                redirectTo: 'slaughterhouses'
              }
            ]
          },
          {
            path: 'products',
            canActivate: [authGuard],
            children: [
              {
                path: 'byproducts',
                component: ViewByproductsPageComponent,
                canActivate: [authGuard]
              },
              {
                path: 'byproducts/:byproductId',
                component: ViewByproductDetailsComponent,
                canActivate: [authGuard]
              },
              {
                path: '',
                pathMatch: 'full',
                redirectTo: 'byproducts'
              },
              {
                path: '**',
                redirectTo: 'byproducts'
              }
            ]
          },
          {
            path: 'services',
            children: [
              {
                path: '',
                component: ViewServicesPageComponent
              },
              {
                path: ':serviceId',
                component: ViewServiceDetailsComponent
              }
            ]
          }
        ]
      },
      {
        path: 'pricing',
        component: PricingComponent,
        canActivate: [authGuard],
        children: [
          {
            path: 'price/:id',
            component: PriceDetailsComponent,
            canActivate: [authGuard]
          },
          {
            path: 'customers',
            canActivate: [authGuard],
            children: [
              {
                path: 'end',
                component: PricingEndProductCustomersPageComponent,
                canActivate: [authGuard]
              },
              {
                path: 'carcass-collection',
                component: PricingCarcassCollectionCustomersPageComponent,
                canActivate: [authGuard]
              },
              {
                path: '',
                redirectTo: 'end',
                pathMatch: 'full'
              },
              {
                path: '**',
                redirectTo: 'end'
              }
            ]
          },
          {
            path: 'partners',
            canActivate: [authGuard],
            children: [
              {
                path: 'slaughterhouses/:slaughterhouseId',
                component: ListPricesForSlaughterhousePageComponent,
                canActivate: [authGuard]
              },
              {
                path: 'slaughterhouses/:slaughterhouseId/price/:id',
                component: PriceDetailsComponent,
                canActivate: [authGuard]
              },
              {
                path: 'slaughterhouses',
                component: PricingSlaughterhousesPageComponent,
                canActivate: [authGuard]
              },
              {
                path: 'logistics/:haulierId',
                component: ListPricesForLogisticsPageComponent,
                canActivate: [authGuard]
              },
              {
                path: 'logistics/:haulierId/price/:id',
                component: PriceDetailsComponent,
                canActivate: [authGuard]
              },
              {
                path: 'logistics',
                component: PricingLogisticsPageComponent,
                canActivate: [authGuard]
              },
              {
                path: '',
                pathMatch: 'full',
                redirectTo: 'slaughterhouses'
              },
              {
                path: '**',
                redirectTo: 'slaughterhouses'
              }
            ]
          },
          {
            path: 'products',
            canActivate: [authGuard],
            children: [
              {
                path: 'byproducts',
                component: PricingByproductsPageComponent,
                canActivate: [authGuard]
              },
              {
                path: 'byproducts/:byproductId',
                component: ListPricesForByproductsPageComponent,
                canActivate: [authGuard]
              },
              {
                path: 'byproducts/:byproductId/price/:id',
                component: PriceDetailsComponent,
                canActivate: [authGuard]
              },
              {
                path: 'end-products',
                component: PricingEndProductsPageComponent,
                canActivate: [authGuard]
              },
              {
                path: 'end-products/price/:id',
                component: PriceDetailsComponent,
                canActivate: [authGuard]
              },
              {
                path: '',
                pathMatch: 'full',
                redirectTo: 'byproducts'
              },
              {
                path: '**',
                redirectTo: 'byproducts'
              }
            ]
          },
          {
            path: 'services',
            children: [
              {
                path: '',
                component: PricingServicesPageComponent
              },
              {
                path: ':serviceId',
                component: ListPricesForServicesPageComponent
              },
              {
                path: ':serviceId/price/:id',
                component: PriceDetailsComponent
              }
            ]
          },
          {
            path: '',
            pathMatch: 'full',
            redirectTo: 'customers'
          },
          {
            path: '**',
            pathMatch: 'full',
            redirectTo: 'customers'
          }
        ]
      },
      {
        path: '',
        redirectTo: 'create',
        pathMatch: 'full'
      }
    ]
  },
  {
    path: 'login',
    component: LoginPageComponent
  },
  {
    path: '',
    component: InitPageComponent
  },
  {
    path: '**',
    redirectTo: '/login'
  }
];
